<!-- <app-header></app-header> -->
<router-outlet></router-outlet>

<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>
<div id="attractions" class="container my-5">
  <div class="row">
    <!-- Left Side -->
    <div class="col-md-5 col-12 mb-4 d-flex align-items-center justify-content-center flex-column text-center">
      <h1 class="explore-heading">EXPLORE</h1>
      <h1 class="explore-subheading">THE CITY</h1>
      <p class="description">
        Our knowledgeable concierge team can assist you in planning your itinerary and arranging tours, tickets, and
        transportation.
      </p>
      <a (click)="scrollToSection('location')" class="contact-button btn btn-primary">Contact Us</a>
    </div>

    <!-- Right Side (Grid of Images) -->
    <!-- {{this.token?.getProperty()?.address?.city}} -->
    <div class="col-md-7 col-12">
      <main *ngIf="blogPosts$ | async as blogPosts">
        <div *ngFor="let blogPost of blogPosts.items; let i = index">
          <div class="row">
            <ng-container *ngFor="let item of blogPost.fields.citiesimages; let j = index">
              <div class="col-md-6 col-12 mb-4"
                *ngIf="j < 4 && blogPost.fields.title === this.tokenStorage?.getProperty()?.address?.city">

                <div *ngIf="blogPost.fields.title === this.tokenStorage?.getProperty()?.address?.city ">

                  <div class="card" style="z-index: 1; margin-bottom: -40px; border-radius: 15px;">
                    <img [src]="item.fields.file.url" class="card-img-top" style="border-radius: 15px;height:200px"
                      alt="This Temple">
                  </div>
                  <div class="card-body text-center card-body-style"
                    style="background-color: var(--primary) !important; margin-left: -10px; margin-right: -10px; border-radius: 10px; padding-top: 50px;">
                    <h5 class="card-title">{{ item.fields.title }}</h5>
                  </div>

                </div>

              </div>
            </ng-container>
          </div>

        </div>
      </main>
    </div>


  </div>
</div>

<div class="nearby-places-section">
  <h2 class="section-heading">Nearby Places</h2>
  <div class="unique-cards-container">
    <div class="card unique-card">
      <img src="assets/images/Nashik.jpg" class="card-img-top" alt="Nashik">
      <div class="card-body">
        <p class="card-text">Nashik</p>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Sambhajinagar.jpg" class="card-img-top" alt="Sambhajinagar">
      <div class="card-body">
        <p class="card-text">Sambhajinagar</p>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Shanishingnapur.jpeg" class="card-img-top" alt="Shanishingnapur">
      <div class="card-body">
        <p class="card-text">Shanishingnapur</p>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Bhimashankar Jyotirlinga.jpeg" class="card-img-top" alt="Bhimashankar Jyotirlinga">
      <div class="card-body">
        <p class="card-text">Bhimashankar Jyotirlinga</p>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/water park.jpg" class="card-img-top" alt="Water Park">
      <div class="card-body">
        <p class="card-text">Water Park</p>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Theme Park.jpg" class="card-img-top" alt="Theme Park">
      <div class="card-body">
        <p class="card-text">Theme Park</p>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Khandoba Temple.jpg" class="card-img-top" alt="Khandoba Temple">
      <div class="card-body">
        <p class="card-text">Khandoba Temple</p>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Panchmukhi Ganesh Temple.jpg" class="card-img-top" alt="Panchmukhi Ganesh Temple">
      <div class="card-body">
        <p class="card-text">Panchmukhi Ganesh Temple</p>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Baba Ka Chawri.jpg" class="card-img-top" alt="Baba Ka Chawri">
      <div class="card-body">
        <p class="card-text">Baba Ka Chawri</p>
      </div>
    </div>
    <div class="card unique-card">
      <img src="assets/images/Ramkund.jpg" class="card-img-top" alt="Ramkund">
      <div class="card-body">
        <p class="card-text">Ramkund</p>
      </div>
    </div>
  </div>
</div>





<div class="unique-carousel-wrapper d-block d-md-none">
  <h2 class="section-heading">Nearby Places</h2>
  <div class="unique-carousel-card shadow-lg border-0 rounded overflow-hidden">
    <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
      <div class="carousel-inner unique-carousel-inner">
        <!-- Loop through the items using Angular's *ngFor -->
        <div *ngFor="let item of carouselItems; let i = index" class="carousel-item" [ngClass]="{ 'active': i === 0 }">
          <div class="unique-carousel-item-content text-center p-3">
            <div class="unique-carousel-item-card">
              <img [src]="item.imgSrc" [alt]="item.title" class="img-fluid circular-image">
              <h2 class="mt-3">{{ item.title }}</h2>
              <p>{{ item.age }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Carousel Controls -->
      <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>
  </div>
</div>









<div class="container my-5">
  <div class="row" id="testimonials">
    <!-- First Column -->
    <div class="col-md-4 mb-4 d-flex flex-column justify-content-center align-items-start">
      <h2 class="headline font-weight-bold mb-3">Real Stays, Real Talk</h2>
      <p class="intro-text mb-4 text-muted">Here's what our guests are saying...</p>
      <a href="https://search.google.com/local/writereview?placeid=ChIJtRi78DJb3DsRB_bv5DiXmc8"
        class="btn btn-primary btn-lg writereview">
        <div style="padding-left: 10px;padding-right: 10px;">
          Write a Review
        </div>
      </a>
    </div>

    <!-- Second Column (Carousel for Desktop) -->
    <!-- <div class="col-md-8 mb-4  d-md-block">
      <div class="card shadow-sm border-0 h-100">
        <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
          <div class="carousel-inner style_carasol" style="display: block">
            <div class="carousel-item" data-interval="10000" *ngFor="let item of googleReviews; let i = index"
              [ngClass]="{ 'active': i === 0 }">
              <div class="row">
                <div class="col-md-12 d-flex align-items-center">
                  <div class="testimonial p-3">


                    <div style="text-align: center;">
                      <div>
                        <img src="assets/images/test.png" alt="{{ item.reviewerName }}"
                          class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;" />
                        <br />
                      </div>

                      <div>
                        <h5 class="font-weight-bold mb-1">{{ item.reviewerName }}</h5>
                      </div>
                      <div>
                        <p class="small text-muted mb-2 review-text">{{ item.reviewText }}</p>
                      </div>

                      <div class="star-ratings text-warning">
                        {{ '★'.repeat(item.rating) }}
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

       Carousel Controls Positioned Outside 
      <div class="carousel-controls">
        <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
        </a>
      </div>
    </div> -->

    <div class="col-md-8 mb-4 d-md-block">
      <div class="card shadow-sm border-0 h-100">
        <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
          <div class="carousel-inner c-review-carousel">

    
            <div class="carousel-item active">
              <div class="row">
                <div class="col-md-12 d-flex justify-content-center">
                  <div class="c-review p-3 text-center">
                    <img src="assets/images/user.png" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;" alt="Sakhi Nandy">
                    <h5 class="font-weight-bold mb-1">Sakhi Nandy</h5>
                    <p class="small text-muted mb-2 c-review-text">
                      Had a great stay at this hotel. Location was perfect. Walking distance from main temple. Service was good. Cleanliless was on point, spacious rooms, clean washroom. Overall it was a pleasant stay!
                    </p>
                    <div class="star-ratings text-warning"> ★★★★★ </div>
                  </div>
                </div>
              </div>
            </div>
    
            <div class="carousel-item ">
              <div class="row">
                <div class="col-md-12 d-flex justify-content-center">
                  <div class="c-review p-3 text-center">
                    <img src="assets/images/user.png" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;" alt="Infotainment with Poonam">
                    <h5 class="font-weight-bold mb-1">Infotainment with Poonam</h5>
                    <p class="small text-muted mb-2 c-review-text">
                      We stayed there for 4 days in August 2023 and it was amazing experience. The service, the behaviour was too good. Especially the manager over there was very kind and ready to help at any point of time, even if you require something not available in the hotel premises, he was ready to go out and get it for you. My father fell ill and he could not eat the food, hence doctor suggested for coconut water and fruits, so he got them for us even at night 10 pm.
We were fully satisfied with the cleanliness round the corner and their attitude towards their customers. The vibes were also good, as it's in close proximity to Sai temple.
                    </p>
                    <div class="star-ratings text-warning"> ★★★★★ </div>
                  </div>
                </div>
              </div>
            </div>
    
            <div class="carousel-item">
              <div class="row">
                <div class="col-md-12 d-flex justify-content-center">
                  <div class="c-review p-3 text-center">
                    <img src="assets/images/user.png" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;" alt="Yasham Kalra">
                    <h5 class="font-weight-bold mb-1">Yasham Kalra</h5>
                    <p class="small text-muted mb-2 c-review-text">
                      Excellent place, rooms are clean and tidy, the service is excellent and prompt. Value for money place, I booked triple bedroom for 2 nights for 4500. Awesome stay for this price. They provided all amenities. Running hot water, tv, ac etc. They even provided 2 bottles of water everyday, dental kit and all toiletries.
                      Also location is excellent, just 5 miss walk to Shirdi temple.
                      I would recommend this to all for stay, nice place for family.
                    </p>
                    <div class="star-ratings text-warning"> ★★★★★ </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="carousel-item">
              <div class="row">
                <div class="col-md-12 d-flex justify-content-center">
                  <div class="c-review p-3 text-center">
                    <img src="assets/images/user.png" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;" alt="Suvarna Gaonkar">
                    <h5 class="font-weight-bold mb-1">Suvarna Gaonkar</h5>
                    <p class="small text-muted mb-2 c-review-text">
                      Hotel Sai S K Palace is very reasonable and walkable from the temple. Ambiance is very pleasant with homely touch. Owner of the hotel is living with family in the same premises, so everything around the hotel is kept very neat and clean. Both the managers are very cooperative and give personal attention to all the guests. I recommend this hotel to all my friends.
                    </p>
                    <div class="star-ratings text-warning"> ★★★★★ </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="carousel-item">
              <div class="row">
                <div class="col-md-12 d-flex justify-content-center">
                  <div class="c-review p-3 text-center">
                    <img src="assets/images/user.png" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;" alt="Bala konar">
                    <h5 class="font-weight-bold mb-1">Bala konar</h5>
                    <p class="small text-muted mb-2 c-review-text">
                      I had a wonderful stay at Hotel Sai SK Palace! The location is perfect—just a short walk from the Sai Baba Samadhi Mandir, making it so convenient for pilgrims. The hotel is very clean, and the rooms are comfortable with all the amenities you need, including air conditioning, a flat-screen TV, and free Wi-Fi. The staff was incredibly helpful and welcoming, which made the stay even better. I highly recommend this hotel to anyone visiting Shirdi. Great experience overall!
                    </p>
                    <div class="star-ratings text-warning"> ★★★★★ </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="carousel-item">
              <div class="row">
                <div class="col-md-12 d-flex justify-content-center">
                  <div class="c-review p-3 text-center">
                    <img src="assets/images/user.png" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;" alt="Anand Chaturvedi">
                    <h5 class="font-weight-bold mb-1">Anand Chaturvedi</h5>
                    <p class="small text-muted mb-2 c-review-text">
                      Nice and divine place to stay. Very clean and rooms are airy. Hotel staffs are Very cooperative and soft spoken. Ample parking is available and hotel is well connected with all means of transport system.
                    </p>
                    <div class="star-ratings text-warning"> ★★★★★ </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="carousel-item">
              <div class="row">
                <div class="col-md-12 d-flex justify-content-center">
                  <div class="c-review p-3 text-center">
                    <img src="assets/images/user.png" class="rounded-circle img-fluid shadow-lg mb-3" style="width: 80px; height: 80px;" alt="ISHWAR NAGPURE">
                    <h5 class="font-weight-bold mb-1">
                      ISHWAR NAGPURE</h5>
                    <p class="small text-muted mb-2 c-review-text">
                      The SK palace is very good property and their service is awesome. hot and cold water and generator is available 24×7, The manager behavior is very professional and the locality of property is peaceful.
                    </p>
                    <div class="star-ratings text-warning"> ★★★★★ </div>
                  </div>
                </div>
              </div>
            </div>
    
          </div>
    
          <!-- Carousel controls -->
          <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="sr-only">Previous</span>
          </a>
          <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="sr-only">Next</span>
          </a>
        </div>
      </div>
    </div>
    




  </div>
</div>






<div id="location" style="margin-bottom: 2px;">
  <div style="position: relative; width: 100%; max-width: 100%; height: 600px;">
    <!-- The iframe -->
    <iframe
      src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d120148.88975519787!2d74.39818439894707!3d19.769900438931444!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x3bdc5b32f0bb18b5%3A0xcf999738e4eff607!2sBus%20Parking%2C%20Pimpalwadi%20Rd%2C%20near%20Neeta%2C%20Shirdi%2C%20Maharashtra%20423109!3m2!1d19.769919299999998!2d74.4805861!5e0!3m2!1sen!2sin!4v1726144551147!5m2!1sen!2sin"
      width="100%" height="100%" style="border:0;" allowfullscreen="" loading="lazy"
      referrerpolicy="no-referrer-when-downgrade"></iframe>
    <div class="card" style="position: absolute; top: 50px; text-align: center; left: 50px; background-color: white; border-bottom-left-radius: 61px;box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    border-top-right-radius: 59px;
    padding: 50px;">
      <h3>Make Unforgettable Memories</h3>
      <p>We're here to assist you with any questions, requests, or bookings.<br> Please don't hesitate to reach out to
        us.</p>
      <button class="book-btn" (click)="navigate()">Book Your Stay</button>
      <p class="contact-footer">
        <i class="fa fa-phone"></i> {{property?.mobile}}
      </p>
      <p class="contact-footer">
        <i class="fa fa-envelope"></i> {{property?.email}}
      </p>

    </div>

  </div>
</div>
<!-- Dialogflow Messenger Integration -->

<df-messenger project-id="impactful-name-306810" agent-id="8bb6c52c-8667-4a24-a789-4cd78b154c96" intent="WEBSITE"
  storage-option="none" language-code="en" max-query-length="-1">
  <df-messenger-chat-bubble id="chatbot" chat-subtitle=""></df-messenger-chat-bubble>
</df-messenger>
<a [href]="getWhatsappShareUrl()" class="float" target="_blank">
  <i class="fa fa-whatsapp my-float"></i>
</a>

<app-footer></app-footer>